var _defs, _rect, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2BInvite1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    role: "img",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b2bInvite1Sky",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f8e7d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#e8c4a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3f2a22"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b2bInvite1Glow",
    cx: "70%",
    cy: "35%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff7ee",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fff7ee",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#b2bInvite1Sky)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1180,
    cy: 280,
    r: 260,
    fill: "url(#b2bInvite1Glow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 640 C 280 520 520 720 820 600 C 1080 500 1320 680 1600 560 L 1600 900 L 0 900 Z",
    fill: "#2b1c18",
    opacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180 900 C 340 620 470 430 640 360 C 720 430 690 620 740 900 Z",
    fill: "#f4efe8",
    opacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2BInvite1);
export default __webpack_public_path__ + "static/media/b2b-invite-1.c9765307773469e0290feecc8990cc8e.svg";
export { ForwardRef as ReactComponent };